import {
    LINK_TOGGLE_CLASS,
    LINK_TOGGLE_REDIRECT_BUTTON_CLASS,
    LINK_TOGGLE_RESET_BUTTON_CLASS,
} from '../../../constant';
import {
    mountRedirectButton,
    mountResetButton,
} from '../../../components/Button';
import { createFormular } from './render';

/**
 * loop through all divs given by classname and calls function "whatToDo"
 * @param selector
 * @param whatToDo
 */
const loopThroughResetDivs = (selector: string, whatToDo: (HTMLSpanElement) => void) => {
    const vfpToggles = document.getElementsByClassName(selector);
    const vfpTogglesLength = vfpToggles.length;
    for (let i = 0; i < vfpTogglesLength; i++) {
        whatToDo(vfpToggles[i]);

    }
};

/**
 * Remove all redirect buttons
 */
export const removeRedirectButton = () => {
    const elements = document.getElementsByClassName(LINK_TOGGLE_REDIRECT_BUTTON_CLASS);
    while (elements.length > 0) {
        elements[0].remove();
    }
};

/**
 * adds "Weitere Adresse prüfen" to all divs "container-reset"
 * @param action
 */
export const initResetFormularButtons = (action) => {
    loopThroughResetDivs(
        LINK_TOGGLE_CLASS, (node: HTMLElement) => {
            const element: HTMLSpanElement = document.createElement('span');
            element.classList.add(LINK_TOGGLE_RESET_BUTTON_CLASS);
            mountResetButton(element, function () {
                createFormular(action);
                action.initForm();
            });
            node.appendChild(element);
    });
};

/**
 * shows or hides special texts
 * @param redirectButtonIsVisible
 */
const handleTextDisplay = (redirectButtonIsVisible: boolean): void => {
     loopThroughResetDivs(
        'noRedirectButton', (noRedirectButtonText: HTMLElement) => {
            if (redirectButtonIsVisible) {
                noRedirectButtonText.style.display = 'none';
            } else {
                noRedirectButtonText.style.display = 'block';
            }
        });

    loopThroughResetDivs(
        'redirectButton', (redirectButtonText: HTMLElement) => {
            if (redirectButtonIsVisible) {
                redirectButtonText.style.display = 'block';
            } else {
                redirectButtonText.style.display = 'none';
            }
        });
};

/**
 * Extracts filename from URL
 * @param URL
 */
const getFilenameFromURL = (URL) => {
    let ret = '';
    if (URL) {
        ret =  URL.split('/').pop();
    }

    return ret;
};

/**
 * adds "Zur Website" in case,the URL of the page differs from the landingpage URL
 * coming from the service.
 * also shows/hides certain texts
 * @param URL that comes as return from api call
 */
export const initRedirectButton = (url?: string, urlContractLp?: string) => {
    /**
     * https://jira.wf-de.vodafone.com/browse/CO-29376
     * We don't check the whole URL but only the pageName
     */
    const redirectUrl = urlContractLp || url;
    const redirectText = urlContractLp ? global.window.additionalPageOptions.redirectContractButtonText : 'Zur Website';
    const pageNameDocument = getFilenameFromURL(window.location.href);
    const pageNameParam = getFilenameFromURL(redirectUrl);
    const displayButton = pageNameDocument !== pageNameParam;

    removeRedirectButton();

    if (displayButton) {

        loopThroughResetDivs(
            LINK_TOGGLE_CLASS, (node: HTMLElement) => {
                const element: HTMLSpanElement = document.createElement('span');
                element.classList.add(LINK_TOGGLE_REDIRECT_BUTTON_CLASS);
                mountRedirectButton(element, redirectUrl, redirectText);
                node.prepend(element);
            });
    }
    // shows/hides additional Texts
    handleTextDisplay(displayButton);

};
